// extracted by mini-css-extract-plugin
export var button = "_5r-0";
export var icon = "_5r-1";